export const categories = [
  { id: "all", name: "全部", slug: "all", icon: "ri-apps-2-line", description: "浏览所有韩国漫画资源" },
  { id: "romance", name: "恋爱", slug: "romance", icon: "ri-heart-line", description: "甜蜜浪漫的恋爱韩漫" },
  { id: "fantasy", name: "奇幻", slug: "fantasy", icon: "ri-magic-line", description: "充满想象力的奇幻世界" },
  { id: "action", name: "动作", slug: "action", icon: "ri-sword-line", description: "热血沸腾的动作漫画" },
  { id: "comedy", name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line", description: "轻松愉快的搞笑漫画" },
  { id: "horror", name: "悬疑", slug: "horror", icon: "ri-ghost-line", description: "紧张刺激的悬疑故事" },
  { id: "drama", name: "剧情", slug: "drama", icon: "ri-film-line", description: "深度剧情感人至深" },
  { id: "school", name: "校园", slug: "school", icon: "ri-building-line", description: "青春校园生活故事" },
  { id: "bl", name: "耽美", slug: "bl", icon: "ri-star-line", description: "精致唯美的耽美漫画" },
  { id: "historical", name: "古风", slug: "historical", icon: "ri-ancient-gate-line", description: "古风韵味的历史故事" },
];

export const categoryMap: Record<string, string> = {
  all: "全部",
  romance: "恋爱",
  fantasy: "奇幻",
  action: "动作",
  comedy: "搞笑",
  horror: "悬疑",
  drama: "剧情",
  school: "校园",
  bl: "耽美",
  historical: "古风",
};